import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import EntityTableRow, { EntityTableRowProps } from 'components/EntityTableRow';
import TableCell from 'components/TableCell';
import Icon from 'components/Icon';

import { RoomPropertiesListRow_roomProperty$key } from '__generated__/RoomPropertiesListRow_roomProperty.graphql';

type Props = EntityTableRowProps & {
  roomProperty: RoomPropertiesListRow_roomProperty$key;
};

const RoomPropertiesListRow: FC<Props> = ({ roomProperty, ...props }) => {
  const roomPropertyData = useFragment(
    graphql`
      fragment RoomPropertiesListRow_roomProperty on RoomProperty {
        id
        icon
        name
        etgKey

        ...EntityTableRow_entity
      }
    `,
    roomProperty
  );

  const { id, icon, name, etgKey } = roomPropertyData;

  return (
    <EntityTableRow entity={roomPropertyData} {...props}>
      <TableCell>{icon && <Icon icon={icon} />}</TableCell>

      <TableCell>
        <Link href={id}>{name}</Link>
      </TableCell>

      <TableCell center>
        <Link href={id}>{etgKey}</Link>
      </TableCell>
    </EntityTableRow>
  );
};

export default RoomPropertiesListRow;
